let appId = "";
switch (process.env.NODE_ENV) {
  case "development":
    appId = "185694923214752";
    break;
  case "staging":
    appId = "185694923214752";
    break;
  case "production":
  default:
    appId = "766897960577610";
    break;
}

export const facebookScope = { scope: "public_profile,email" };

export const initFacebookSDK = () => {
  return new Promise((resolve) => {
    window.fbAsyncInit = (function() {
      FB.init({
        appId: appId,
        xfbml: true, // parse social plugins on this page
        version: "v2.8", // use graph api version 2.8
      });
    })(
      (function(d, s, id) {
        var js,
          fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s);
        js.id = id;
        js.src = "//connect.facebook.net/en_US/all.js";
        fjs.parentNode.insertBefore(js, fjs);
      })(document, "script", "facebook-jssdk")
    );
  });
};
